import { NgModule } from '@angular/core';
import { SmartModalModule } from '@certemy/ui-components';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { NgbCustomModalComponent } from 'components/modal-windows/ngb-custom-modal/ngb-custom-modal.component';

@NgModule({
  imports: [CertemyCommonModule, SmartModalModule.forRoot()],
  exports: [NgbCustomModalComponent],
  declarations: [NgbCustomModalComponent],
})
export class NgbCustomModalModule {}
